
import dayjs from "dayjs";

const {
    page_name,
    page_key,
    site,
    landing_page_enabled,
    is_mobile_device,
} = window.tg;

export default () => {
    return {
        picker: null,
        init() {
            const updated_search_form = document.querySelector('#search-form-updated');

            this.picker = window.flatpickr(this.$refs.start, {
                plugins: [new window.yearDropdownPlugin({
                    date: this.$store.search.start != '' ? dayjs(this.$store.search.start).format('YYYY-MM-DD') : '',
                    yearStart: 0,
                    yearEnd: 2
                })],
                position: "below",
                positionElement: updated_search_form && is_mobile_device ? document.querySelector('.start-date'): undefined,
                clickOpens: false,
                mode: 'single',
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'j M Y',
                locale: {
                    firstDayOfWeek: 1
                },
                minDate: 'today',
                disableMobile: true,
                maxDate: site === 'vy' ? dayjs('2025-06-30').toDate() : dayjs().add(2,'year').toDate(),
                defaultDate: this.$store.search.start != '' ? dayjs(this.$store.search.start).format('YYYY-MM-DD') : '',
                static: site === "vy" ? true : false,
                onValueUpdate: (selectedDates, dateString) => {
                    if (dateString != this.$store.search.start) {
                        this.$store.search.start = dayjs(dateString).format('YYYY-MM-DD')
                        this.$nextTick(() => this.$store.search.houseKeeping('end'))
                    }
                },
                onOpen: () => {
                    const element = site == "ec" ? document.querySelector('#search-form-container') : document.querySelector('.search-summary-dropdown');

                    if (this.$store.search.datesRequired) {
                        let alertEl = document.createElement('div');
                        alertEl.className = 'alert alert-error mb-0 font-size-sm';
                        alertEl.innerHTML = _t('kd.results.enter_dates_pls','Please enter dates before sorting or filtering');
                        this.picker.calendarContainer.prepend(alertEl);

                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });

                        Alpine.store('search').activeSection = '';
                        Alpine.store('search').datesRequired = false;
                    } else if (this.$store.search.total >= 3 && this.$store.search.start === '') {
                        let dismissCalendarElement = document.createElement('div');
                        dismissCalendarElement.className = 'alert w-100 text-primary font-size-sm px-3 py-2 d-flex justify-content-between align-items-center rounded-top';
                        dismissCalendarElement.style.backgroundColor = '#FDF0E6';
                        dismissCalendarElement.style.border = '1px solid #FBE4D6';
                        dismissCalendarElement.innerHTML = `
                            <div>
                                <i class="far fa-info-circle text-center text-primary mr-2"></i>
                                <span>${_t('kd.results.search_dates_required', 'Dates required to search')}</span>
                            </div>

                            <button class="close-btn">
                                <i class="fal fa-xmark text-primary text-center font-size-md" aria-label="Close"></i>
                            </button>
                        `;

                        const closeButtonElement = dismissCalendarElement.querySelector('.close-btn');
                        if (closeButtonElement) {
                            closeButtonElement.addEventListener('click', (event) => {
                                this.picker.close();
                            });
                        }

                        this.picker.calendarContainer.prepend(dismissCalendarElement);
                    }

                    if (this.$store.search.extendDates) {
                        let alertEl = document.createElement('div');
                        alertEl.className = 'alert bg-medium-light mb-0 px-3 py-2 font-size-sm';
                        alertEl.innerHTML = _t('kd.results.extend_stay','Try extending your stay to find even more places');
                        this.picker.calendarContainer.prepend(alertEl);

                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });

                        Alpine.store('search').activeSection = '';
                        Alpine.store('search').extendDates = false;
                    }
                },

                onClose: () => {
                    this.picker.calendarContainer.querySelector('.alert')?.remove();

                    if (this.$store.search.datesRequired && this.$store.search.start == '') {
                        this.$store.search.activeSection = ''
                        this.$store.search.datesRequired = false

                        if (page_name === 'results.region') {
                            window.resetRequiredFilters()
                        } else if(page_name === 'results.map') {
                            window.resetMapRequiredFilters()
                        }
                    }

                    if (this.$store.search.end == '') {
                        this.picker.clear() // not using clear since sets date to []
                    }
                }
            })

            this.$watch('$store.search.start', () => {
                let date = this.$store.search.start != '' ? dayjs(this.$store.search.start).format('YYYY-MM-DD') : ''
                this.picker.setDate(date)
            })

            this.$watch('$store.search.activeSection', (newValue) => {
                // Don't allow the date picker to open on mobile when the search tray is closed
                if (is_mobile_device && page_key !== 'homepage' && this.$store.general.openSection !== 'SEARCH') return;

                // unsure when search form is teleported on desktop why two datepickers are opened even if $refs is undefined.
                if (newValue == 'start' && this.$refs.start !== undefined) this.picker.open()
            })

            this.$watch('$store.general.openSection', (newValue, oldValue) => {
                if (oldValue == 'SEARCH') this.picker.close()
            })

            if (landing_page_enabled && !this.$store.search.start) {
                this.picker.open();
            }

            // Close datepicker on window resize if landing_page_enabled is true
            if (landing_page_enabled) {
                this._resizeHandler = () => {
                    if (this.picker) this.picker.close();
                };
                window.addEventListener('resize', this._resizeHandler);
            }
        },
    }
}


